import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ISupplementRequest } from 'src/app/model/supplement/isupplement-request';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SupplementService {

  constructor(private httpClient: HttpClient) { }

  public submitSupplement(request: ISupplementRequest): Observable<void> {
    return this.httpClient.post<void>(environment.baseUrl + '/v1/submitSupplement', request);
  }
}
